import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initLocale } from './i18n';
import { net } from './net';
import './styles.css';
import { loadThemeIndex } from './theme/registry';

// Before the first render: a saved choice, else the closest match from
// `navigator.languages`, else English.
initLocale();

void loadThemeIndex();

// A shared link looks like `/r/ABCDE`. Hand it to the net layer before the
// socket opens so the join fires as soon as the session handshake completes.
const deepLink = location.pathname.match(/^\/r\/([A-Za-z0-9]{4,8})\/?$/);
net.setPendingJoin(deepLink ? deepLink[1].toUpperCase() : null);

net.connect();

// Coming back to a backgrounded tab should reconnect immediately rather than
// waiting out the backoff.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') net.connect();
});
window.addEventListener('online', () => net.connect());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
